import React, { useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFPreview = React.memo(({ pdfFile }) => {
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        if (!pdfFile) {
            setPdfUrl(null);
            return undefined;
        }

        const nextPdfUrl = URL.createObjectURL(new Blob([pdfFile], { type: 'application/pdf' }));
        setPdfUrl(nextPdfUrl);

        return () => URL.revokeObjectURL(nextPdfUrl);
    }, [pdfFile]);

    return (
        <div className="pdf-viewer-frame">
            {pdfUrl && (
                <embed className="pdf-viewer-embed" src={`${pdfUrl}#view=FitH`} type="application/pdf" />
            )}
        </div>
    );
});

export default PDFPreview;
